import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import checkchallanImage from "../../assets/challan-online.png";
import indIcon from "../../assets/Ind.png";
import styles from "./SellYourCar.module.css";
import LoanCard from "../../components/LoanCard";
// Loan icons
import fairPriceIcon from "../../assets/fair-price.png";
import sellIcon from "../../assets/Sell-from-anywhere.png";
import multipleIcon from "../../assets/multi-partner.png";
import hasselIcon from "../../assets/hassel-free.png";
import FAQSection from "../../components/FAQSection";
import OurPartners from "../../components/OurPartners";

function SellYourCar() {
  const navigate = useNavigate();
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [error, setError] = useState("");

  const loans = [
    { id: 1, title: "Fair Price", image: fairPriceIcon },
    { id: 2, title: "Sell from anywhere", image: sellIcon },
    { id: 3, title: "Multi-Partner Support", image: multipleIcon },
    { id: 4, title: "Hassle-free experience", image: hasselIcon },
  ];

  const validateVehicleNumber = (number) => {
    const cleanedNumber = number.replace(/\s/g, "").toUpperCase();

    const regex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,3}[0-9]{1,4}$/;

    const validStateCodes = [
      "AN", "AP", "AR", "AS", "BR", "CH", "CG", "DD", "DL", "GA", "GJ", "HR", "HP",
      "JH", "JK", "KA", "KL", "LD", "MP", "MH", "MN", "ML", "MZ", "NL", "OD", "PY",
      "PB", "RJ", "SK", "TN", "TS", "TR", "UP", "UK", "WB"
    ];

    if (!cleanedNumber) {
      return "Please enter a vaahan number";
    }

    if (!regex.test(cleanedNumber)) {
      return "Invalid vaahan number format. Please enter a valid Indian vaahan number (e.g., DL3SDW2595, UP57BX1666).";
    }

    const stateCode = cleanedNumber.substring(0, 2);
    if (!validStateCodes.includes(stateCode)) {
      return "Invalid state code. Please use a valid Indian state code (e.g., DL, MH, UP).";
    }

    return "";
  };

  const handleSearch = () => {
    const validationError = validateVehicleNumber(vehicleNumber);
    setError(validationError);
    if (!validationError) {
      navigate("/sellYourCarDetails", { state: { vehicleNumber } });
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        {/* Left Content */}
        <div className={styles.leftContent}>
          <div className={styles.headerGroup}>
            <h1 className={styles.title}>
              Get The <span className={styles.highlight}>Best Price</span> For
              Your Car
            </h1>
            <p className={styles.subtitle}>
              Instant Quote. Multiple Partners. Same Day Processing
            </p>
          </div>

          {/* Search Box */}
          <div className={styles.searchBox}>
            <div className={styles.searchContainer}>
              <div className={styles.indSection}>
                <div className={styles.prefix}>
                  <img src={indIcon} alt="IND" />
                </div>
              </div>
              <input
                type="text"
                placeholder="MH15CV2211"
                className={styles.searchInput}
                value={vehicleNumber}
                onChange={(e) => setVehicleNumber(e.target.value.toUpperCase())}
              />
              <button
                className={styles.searchButton}
                onClick={handleSearch}
              >
                <Search size={20} />
              </button>
            </div>
            {error && <p className={styles.error}>{error}</p>}
          </div>
        </div>

        {/* Right Image */}
        <div className={styles.rightContent}>
          <div className={styles.imageWrapper}>
            <div className={styles.blueCircle}></div>
            <img
              src={checkchallanImage}
              alt="Traffic officer checking vaahan with driver using smartphone app"
              className={styles.image}
            />
          </div>
        </div>
      </div>
      {/* Loans Section */}
      <div className="loan-section">
        <h2 className="loan-header">Why Sell Your Car on VAAHANBUDDY</h2>
        <div className="loan-scroll">
          {loans.map((loan, index) => (
            <LoanCard key={index} title={loan.title} image={loan.image} />
          ))}
        </div>
      </div>
      <FAQSection />
      <OurPartners />
    </div>
  );
}

export default SellYourCar;